var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-userform"},[(_vm.edituser && _vm.edituser.fields)?_c('div',[_c('v-userform',{attrs:{"rolename":_vm.edituser.role,"uid":_vm.edituser.id,"isnew":!_vm.edituser.id,"formfields":_vm.edituser.fields}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c1a04c06","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/p-userform.vue
// module id = null
// module chunks = 